import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=4a4ff621"
import script from "./Qualifications.vue?vue&type=script&lang=js"
export * from "./Qualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports